function _handleNullValue(value) {
  return value === 'null' ? null : value;
}

export function getRadioChange(
givenValue,
shouldReturnOptionAllSelection)
{
  const value = _handleNullValue(givenValue);
  if (String(value).toLowerCase() === 'all' && !shouldReturnOptionAllSelection) {
    return [];
  }

  if (String(value).includes(',')) {
    return value ? value.split(',') : [];
  }

  return [value];
}

export function isRadioChecked(
givenValue,
selectedValues,
shouldReturnOptionAllSelection)
{
  const value = _handleNullValue(givenValue);

  // - - - - - - - - - - - - - - - - - - - -
  // if shouldReturnOptionAllSelection = true
  // - - - - - - - - - - - - - - - - - - - -

  if (shouldReturnOptionAllSelection) {
    if (String(value).includes(',')) {
      return value ? value.split(',').every((val) => selectedValues.includes(val)) : [];
    }
    if (selectedValues.includes(value)) {
      return true;
    }
    return false;
  }

  // - - - - - - - - - - - - - - - - - - - -
  // if shouldReturnOptionAllSelection = false
  // - - - - - - - - - - - - - - - - - - - -

  if (String(value).toLowerCase() === 'all' && selectedValues.length === 0) {
    return true;
  }
  if (String(value).includes(',')) {
    return value ? value.split(',').every((val) => selectedValues.includes(val)) : [];
  }
  if (selectedValues.includes(value)) {
    return true;
  }

  return false;
}